// noinspection ES6UnusedImports
import {useEffect} from 'react';
import fetchWithCSRF from '@core/scripts/helper/fetch-with-csrf';
import Url from '@core/scripts/helper/url';
import Messages from '@core/scripts/components/messages.js';
import MessageBroker from '@bonprix/pattern-library/components/message-broker.js';
import LandmarkHelper from '@core/scripts/components/tracking/helper';

export default function ConsentSessionStartStatusChecker() {
	const localStorageIdentifier = 'CONSENT_COMMUNICATED_STATUS';
	const sessionLandmarkIdentifier = 'consentLandmarked';

	const updateAllConsentStates = () => {
		const vendorStates = window.hc_consent.getConsents();
		const categoryStates = window.hc_consent.getCategoriesConsents();
		const externalConsents = window.hc_consent.getExternalConsents();

		if (
			vendorStates !== undefined &&
			vendorStates !== null &&
			categoryStates !== undefined &&
			categoryStates !== null &&
			externalConsents !== undefined &&
			externalConsents !== null
		) {
			let sessionIdentifier = LandmarkHelper.getSessionId();
			if (!window.hc_consent.isNewUser()) {
				let sessionStartIdentifier = localStorage.getItem(sessionLandmarkIdentifier);
				if (!sessionStartIdentifier || sessionStartIdentifier !== sessionIdentifier) {
					fetchWithCSRF(Url.toAbsolute('/ajax/consent/sessionStart/tracking/'), {
						method: 'POST',
						headers: new Headers({
							                     'Content-Type': 'application/json',
						                     }),
						body: JSON.stringify({vendorStates: vendorStates, categoryStates: categoryStates, externalVendorIds: externalConsents}),
					}).then(() => {
						localStorage.setItem(sessionLandmarkIdentifier, sessionIdentifier);
						localStorage.setItem(localStorageIdentifier, JSON.stringify(vendorStates));
					});
				}
			} else {
				localStorage.setItem(sessionLandmarkIdentifier, sessionIdentifier);
				localStorage.setItem(localStorageIdentifier, JSON.stringify(vendorStates));
			}
		} else if (vendorStates === undefined) {
			fetchWithCSRF(Url.toAbsolute('/ajax/consent/error/'), {
				method: 'POST',
				headers: new Headers({
					                     'Content-Type': 'application/json',
				                     }),
				body: JSON.stringify({message: 'Consent state unexpectedly undefined, consent cookies set to opt-out'}),
			});
		}
	};

	const initNitro = (consent) => {
		MessageBroker.publish(Messages.OPTIN.MARKETING_STATUS_CHANGED, {optIn: consent});
	};

	const initHurraTracking = (consent) => {
		MessageBroker.publish(Messages.OPTIN.COMPLETE_CONSENT_GIVEN);
	};

	useEffect(() => {
		window['nitroInitializer'] = initNitro;
		window['hurraTrackingInitializer'] = initHurraTracking;
		const interval = setInterval(() => {
			if (window.hc_consent !== undefined) {
				updateAllConsentStates();
				clearInterval(interval);
			}
		}, 100);
	}, []);
}
